import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { APP_TYPE, formatDate } from "../../config/Config";
import { Image } from "primereact/image";
import { useEffect, useRef, useState } from "react";
import PoliticalPartyRequirements from "./PoliticalPartyRequirements";
import { useContext } from "react";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import ScreenLoader from "../../componets/ScreenLoader";
import { InputText } from "primereact/inputtext";
import InputTextArea from "../../componets/InputTextArea";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import UseError from "../../componets/UseError";
import { PrimeIcons } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { AppDB } from "../../App";
import { contestationPeriodsService } from "../../services/ContestationPeriodsService";

export default function ({ header = null, }) {
    var { setRefresh_PoliticalParties, refresh_politicalParties, selectedParty, contestationPeriodID, setContestationPeriodID, setSelectedParty, setContestationPeriod, } = useContext(PoliticalPartyDBContext);
    var { toast } = useContext(AppDB);

    var political = new PoliticalPartyService()
    var [loading, setLoading] = useState(false);
    var [submit, setSubmit] = useState(false);
    var [refreshRequirements, setRefreshRequirements] = useState(0);
    var [contestationPeriodList, setContestationPeriodList] = useState([]);

    var [cloneParty, setCloneParty] = useState(JSON.parse(JSON.stringify(selectedParty)));
    const [checked, setChecked] = useState(false);


    var { SetFormError, updateForm, formErrors } = UseError();
    var [formErrorMessage, setFormErrorMessage] = useState({});
    useEffect(() => {
        SetFormError({
            name: "required|limit:200",
            description: "required|limit:200",
            abbreviation: "required|limit:200",
            // slogan: "required|limit:200",
            registeredDate: "required|limit:200",
            logo: "required",
            emailAddress: "required|email",

        });
    }, []);

    const inputFileRef = useRef(null);
    const constitutionFileRef = useRef(null);
    const societyActRegisteredFileRef = useRef(null);


    async function onInputChange(event, _name = null) {
        var name = event?.target?.name;

        await setCloneParty({ ...cloneParty, [name]: event?.value || event?.target?.value.toUpperCase() });
        var res = await updateForm(name, event?.value || event?.target?.value, cloneParty);
        if (res.trim().length === 0) {
            await delete formErrorMessage[name];
            setFormErrorMessage({ ...formErrorMessage });
        } else {
            setFormErrorMessage({ ...formErrorMessage, [name]: res });
        }
    }



    const onBtnClick = () => {
        inputFileRef.current.click();
    };

    const onBtnConstitutionClick = () => {
        constitutionFileRef.current.value = ""
        constitutionFileRef.current.click();
    };
    const onBtnSocietyActRegisteredClick = () => {
        societyActRegisteredFileRef.current.value = ""
        societyActRegisteredFileRef.current.click();
    };

    var convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    async function onUploadHandler(e) {
        const file = e.files[0];
        const base64 = await convertBase64(file);
        var base64result = base64;
        await delete formErrorMessage.logo;
        setFormErrorMessage({ ...formErrorMessage });
        const extension = file.name.split(".").pop();
        setCloneParty({ ...cloneParty, logo: base64result, logoExtension: extension, logoContentType: file.type });
    }

    async function onConstitutionUploadHandler(e) {
        const file = e.files[0];
        const base64 = await convertBase64(file);
        var base64result = base64;
        await delete formErrorMessage.constitution;
        setFormErrorMessage({ ...formErrorMessage });
        const extension = file.name.split(".").pop();
        setCloneParty({
            ...cloneParty,
            constitution: base64result,
            constitutionFileName: file.name,
            constitutionExtension: extension,
            constitutionContentType: file.type
        });
    }

    async function onSocietyActRegisteredUploadHandler(e) {
        const file = e.files[0];
        const base64 = await convertBase64(file);
        var base64result = base64;
        await delete formErrorMessage.constitution;
        setFormErrorMessage({ ...formErrorMessage });
        const extension = file.name.split(".").pop();
        setCloneParty({
            ...cloneParty,
            societyActRegistration: base64result,
            societyActRegistrationFileName: file.name,
            societyActRegistrationExtension: extension,
            societyActRegistrationContentType: file.type,
            societyActRegistration_error: ""
        });
    }


    useEffect(() => {
        if (APP_TYPE === "PoliticalParty" || submit === true) {
            setLoading(true)
            political.getAllPoliticalPartyByID(selectedParty.politicalPartyID).then(res => {
                setSelectedParty(res)
                // setContestationPeriodList(res.contestationYears)
                setLoading(false)
                setCloneParty(JSON.parse(JSON.stringify(res)));

                contestationPeriodsService.getContestationPeriods().then(res => {
                    setContestationPeriod(res)
                    res.forEach(res => {
                        if (res.isCurrent) {
                            if (["", null, undefined].includes(contestationPeriodID)) {
                                setContestationPeriodID(res.contestationPeriodID)
                                return;
                            }

                        }
                    })
                    setLoading(false)
                })
            })
        } else {
            political.getAllPoliticalPartyByID(selectedParty.politicalPartyID).then(res => {
                setSelectedParty(res)
                // setContestationPeriodList(res.contestationYears)
                setLoading(false)
                setCloneParty(JSON.parse(JSON.stringify(res)));

            })
            if (selectedParty.politicalPartyID !== null && contestationPeriodID !== null) {
                // setContestationPeriodList(selectedParty.contestationYears)


            }
        }
    }, [submit, contestationPeriodID])



    useEffect(() => {
        var exist = contestationPeriodList.findIndex(e => e.contestationPeriodID === contestationPeriodID)
        if (exist < 0 && contestationPeriodList.length > 0) {

            if (selectedParty.politicalPartyID !== null && contestationPeriodID !== null && APP_TYPE !== "PoliticalParty") {
                setLoading(true)
                contestationPeriodsService.updatePoliticalPartycontestationYears({
                    "politicalPartyID": selectedParty.politicalPartyID,
                    "contestationPeriodID": contestationPeriodID,
                    "carryOverExecutiveMembers": true,
                    "carryOverDocuments": true

                }).then(res => {
                    setLoading(false)
                    setRefreshRequirements(!refreshRequirements)
                })
            }

        }
    }, [contestationPeriodID, contestationPeriodList, selectedParty])









    async function onInputChange(event,) {
        var name = event?.target?.name;
        // console.log(event?.value || event?.target?.value)

        var res = "";
        if (event?.value == 0) {
            await setCloneParty({ ...cloneParty, [name]: 0 })
            res = await updateForm(name, 0, cloneParty)
        }
        else {
            await setCloneParty({ ...cloneParty, [name]: event?.value || event?.target?.value?.toUpperCase() })
            res = await updateForm(name, event?.value || event?.target?.value, cloneParty)
        }

        if (res.trim().length === 0) {
            await delete formErrorMessage[name];
            setFormErrorMessage({ ...formErrorMessage })
        }
        else {
            setFormErrorMessage({ ...formErrorMessage, [name]: res })
        }
    }


    async function SubmitForm() {
        var error = {};
        var haveError = false;
        for (let key in formErrors) {
            if (formErrors.hasOwnProperty(key)) {
                var res = await updateForm(key, cloneParty[key], cloneParty);
                if (res.length > 2) {
                    console.log(key, res);
                    haveError = true;
                    error[key] = res;
                }
            }
        }



        await setFormErrorMessage({ ...formErrorMessage, ...error });

        if (haveError) {
            return toast.show({
                severity: "error",
                detail: "Please fill in all required fields",
                life: 2500
            });
        }


        var PoliticalParty = new PoliticalPartyService();
        var clone = JSON.parse(JSON.stringify(cloneParty));

        var cloneImageLogo = clone?.logo?.split(",");
        if (cloneImageLogo?.length >= 2) {
            clone.logo = cloneImageLogo[1];
        }
        setLoading(true);
        setSubmit(false);
        PoliticalParty.updateParty(clone)
            .then((res) => {
                if (res.success) {
                    setLoading(false);
                    setSubmit(true)
                    setChecked(false)
                    toast.show({
                        severity: "success",
                        detail: "Political Party Updated",
                        life: 2500
                    });
                } else {
                    setLoading(false);
                    toast.show({
                        severity: "error",
                        detail: res.message,
                        life: 2500
                    });
                }
            })
            .catch((e) => {
                setLoading(false);
                return toast.show({
                    severity: "error",
                    summary: "Error",
                    detail: "Ooops, The is a technical problem,Please Try Again",
                    life: 2000
                });
            });

    }



    useEffect(() => {
        const button = document.getElementById("update_political_party_button")

        const handleClick = () => {
            SubmitForm()
        };

        // Attach the click event listener to the button

        if (button) {
            //  button.style.display="none"
            button.disabled = !checked;
            button.addEventListener('click', handleClick);
        }
        // Cleanup the event listener when the component unmounts or ref changes
        return () => {
            if (button) {
                button.removeEventListener('click', handleClick);
            }
        };
    }, [checked, cloneParty]); // Empty dependency array to ensure this runs only once on mount

    var politicalPartyTableDetails = [
        {
            name: "Party name",
            value: checked ? <div>
                <InputText className="w-full" name="name" value={cloneParty?.name} onChange={e => onInputChange(e)} />
                <br />
                <small style={{ width: "100%" }} className="p-error">
                    {formErrorMessage?.name}
                </small>
            </div> : selectedParty?.name,
        },
        {
            name: "Abbreviation",
            value: checked ? <div>
                <InputText name="abbreviation" className="w-full" value={cloneParty?.abbreviation} onChange={e => onInputChange(e)} />
                <br />
                <small style={{ width: "100%" }} className="p-error">
                    {formErrorMessage?.abbreviation}
                </small>
            </div> : selectedParty?.abbreviation,
        },
        {
            name: "Official Party Email Address",
            value: checked ? <div>
                <InputText name="emailAddress" className="w-full" value={cloneParty?.emailAddress} onChange={e => onInputChange(e)} />
                <br />
                <small style={{ width: "100%" }} className="p-error">
                    {formErrorMessage?.emailAddress}
                </small>
            </div> : selectedParty?.emailAddress,
        },
        {
            name: "Description",
            value: checked ? <div>
                <InputTextArea className="w-full" name={"description"} value={cloneParty?.description} onChange={e => onInputChange(e)} />
                <br />
                <small style={{ width: "100%" }} className="p-error">
                    {formErrorMessage?.description}
                </small>
            </div> : selectedParty?.description,
        },
        // {
        //     name: "Slogan",
        //     value: checked ? <div>
        //         <InputText className="w-full" name="slogan" value={cloneParty?.slogan} onChange={e => onInputChange(e)} />
        //         <br />
        //         <small style={{ width: "100%" }} className="p-error">
        //             {formErrorMessage?.slogan}
        //         </small>
        //     </div> : selectedParty?.slogan,
        // },
        {
            name: "Date Registered",
            value: checked ? <div>
                <Calendar className="w-full" name="registeredDate" value={new Date(cloneParty?.registeredDate)} onChange={e => onInputChange(e)} />
                <br />
                <small style={{ width: "100%" }} className="p-error">
                    {formErrorMessage?.registeredDate}
                </small>
            </div> : formatDate(selectedParty?.registeredDate),
        },
        // {
        //     name: "Anniversary",
        //     value: checked ? <div>
        //         <Calendar className="w-full" name="annivesary" value={new Date(cloneParty?.annivesary)} onChange={e => onInputChange(e)} />
        //         <br />
        //         <small style={{ width: "100%" }} className="p-error">
        //             {formErrorMessage?.annivesary}
        //         </small>
        //     </div> : formatDate(selectedParty?.annivesary),
        // },
        // {
        //     name: "Logo",
        //     value: <Image preview={true} src={selectedParty?.logo} template="Logo" alt="Logo" width="50px" style={{ width: "50px", objectFit: "cover" }} />,
        // },
        // {
        //     "name": "Registered under society's act",
        //     value: !checked ? (selectedParty?.societyActRegistered ? "Yes" : "No") : (<div className="col-12  lg:col-4">
        //         <Checkbox
        //             id="societyActRegistered"
        //             checked={cloneParty.societyActRegistered}
        //             name="societyActRegistered"
        //             label="societyActRegistered"
        //             required={true}
        //             value={cloneParty.societyActRegistered}
        //             optionLabel="abbreviation"
        //             onChange={(e) => setCloneParty({ ...cloneParty, societyActRegistered: e.checked })}
        //         />
        //         {/* <label htmlFor="societyActRegistered" className="ml-2">Registered under society's act</label> */}
        //     </div>)
        // }
        // ,
        {
            name: "",
            value: (<>
                <div className="grid">
                    <div className="col-12  lg:col-4">
                        <label htmlFor="description">
                            Logo/Symbol {checked && <span style={{ color: "red" }}>*</span>}
                        </label>{" "}
                        <br></br>
                        <div style={{ visibility: "hidden" }}>LOGO</div>
                        <>
                            <Button
                                style={{ display: !checked ? "none" : "block" }}

                                label={cloneParty?.logo?.trim().length === 0 ? "Select a file" : "Logo Added"}
                                onClick={onBtnClick}
                                className="p-button-success w-full"
                                icon={cloneParty?.logo?.trim().length === 0 ? "pi pi-plus" : ""}
                            />
                            <input
                                ref={inputFileRef}
                                type={"file"}
                                onChange={(e) => onUploadHandler(e.target)}
                                style={{ display: "none" }}
                                accept="image/*"
                            ></input>
                        </>
                        <small style={{ width: "100%" }} className="p-error">
                            {formErrorMessage.logo}
                        </small>
                        <div style={{ visibility: "hidden" }}>LOGO</div>

                        {cloneParty?.logo?.trim().length === 0 ? (
                            ""
                        ) : (
                            <Image
                                preview={true}
                                src={`${cloneParty.logo}`}
                                alt="Logo"
                                width="100px"
                                style={{ width: "100px", objectFit: "cover" }}
                            />
                        )}
                    </div>
                </div>

            </>)
        }
    ];


    if (APP_TYPE === "Central") {
        politicalPartyTableDetails.unshift({
            name: "Edit",
            value: <InputSwitch checked={checked} onChange={(e) => setChecked(e.value)} />
        });
    }


    return (<>
        <ScreenLoader visible={loading} />
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
            {header !== null && <h5>{header}</h5>}
        </div>
        <DataTable size="small" scrollable={true} value={politicalPartyTableDetails} dataKey="id" responsiveLayout="scroll" resizableColumns>
            <Column style={{ width: "100px" }} body={(e) => <b>{e.name}</b>}></Column>
            <Column body={(e) => e.value}></Column>
        </DataTable>
        {!checked && (<PoliticalPartyRequirements key={refreshRequirements} />)}

    </>)
}